import { Flex, Modal, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { MonoValue } from 'src/components'

const { Text } = Typography

type Props = {
  /** null keeps the modal closed; a value opens it. */
  secret: string | null
  onClose: () => void
}

/** Shown from both the list and the detail page, which reveal the same secret the same way. */
export const SigningSecretModal = ({ secret, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={secret !== null}
      onCancel={onClose}
      footer={null}
      title={t(
        'workspace.apps.outboundWebhooks.secret.title',
        'Signing secret'
      )}
    >
      <Flex vertical gap={12}>
        <Text type="secondary">
          {t(
            'workspace.apps.outboundWebhooks.secret.hint',
            'Give this to whoever receives the events — they use it to verify the X-CRM-Signature header. Every time it is shown here is recorded in the activity log.'
          )}
        </Text>
        {secret ? <MonoValue>{secret}</MonoValue> : null}
      </Flex>
    </Modal>
  )
}
